<template>
  <el-dialog
    custom-class="single-statement"
    title="工单拆分"
    :visible.sync="splitShow"
    :close-on-click-modal="false"
    width="1200px"
    :modal-append-to-body="false"
    :append-to-body="true"
    :before-close="closeDialog"
  >
    <el-row>
      <el-col :span="12" style="border-right: 1px solid rgba(187, 187, 187, 1)">
        <div class="front-line mb" style="margin-left: 50px">原工单</div>
        <el-scrollbar style="height:520px;">
          <div v-loading="loading" class="pb" style="width: 480px;margin: 0px auto;">
            <el-form ref="orderForm" :model="order" label-position="left" class="single-form" label-width="120px">
              <el-form-item label="工单号" prop="process_no">
                <el-row>
                  <el-col :span="18" class="flex align-items-center">
                    <el-link v-if="order.workorder_no" :underline="false" @click="toDetail(order)">
                      <div class="order-no">{{ order.workorder_no }}</div>
                    </el-link>
                    <span v-else>{{ "自建工单" }}</span>
                    <el-tooltip content="主工单" placement="top" class="ml-xs" v-if="order.type == 1" >
                      <icon-svg icon-class="maintask" style="font-size: 22px"/>
                    </el-tooltip>
                    <el-tooltip content="子工单" placement="top" class="ml-xs" v-else-if="order.type == 2">
                      <icon-svg icon-class="subtask" style="font-size: 22px"/>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="工单内容">
                <span>{{ order.workorder_title }}</span>
              </el-form-item>

              <el-form-item v-if="order.remark" label="工单备注">
                <span>{{ order.remark }}</span>
              </el-form-item>

              <el-form-item label="生产信息">
                <div class="flex justify-content-space-between font-12">
                  <span>开工时间</span>
                  <span>
                    <span v-if="Number(order.non_defective_num)" class="text-success mr-sm border-success">合格 {{ order.non_defective_num }} 件</span>
                    <span v-if="Number(order.defective_num)" class="text-danger border-danger">不合格 {{ order.defective_num }} 件</span>
                  </span>
                  <span>完工时间</span>
                </div>

                <el-progress v-if="order.status >= 80" :percentage="100" :show-text="false" color="#06793d"></el-progress>

                <div class="flex justify-content-space-between font-12">
                  <span>{{ order.starttime | parseTime("{y}-{m}-{d} {h}:{i}") }}</span>
                  <span class="text-success">
                    <span v-if="order.status >= 80" class="mr-sm">
                      共用时 {{
                      order.standard_unit == "min"
                      ? parseInt((order.endtime - order.starttime) / 60) +
                      " " +
                      order.standard_unit
                      : parseInt((order.endtime - order.starttime) / 3600) +
                      " " +
                      order.standard_unit
                      }}
                    </span>
                  </span>
                  <span v-if="order.status >= 80">{{ order.endtime | parseTime("{y}-{m}-{d} {h}:{i}") }}</span>
                </div>
              </el-form-item>

              <el-form-item v-if="order.create_from === 0" label="派工工时" class="mt">
                <span class="text-muted">
                  （
                  <span class="number text-bold font-16 text-black">{{ order.plan_num }}</span>
                  件 &#215;
                  <span class="number font-16 text-bold text-black">{{ order.standard_hour }}</span>
                  {{ order.standard_unit }}/件 ）+
                  <span class="number text-bold font-16 text-black">{{ order.add_hour }}</span>
                  {{ order.standard_unit }} =
                  <span class="number font-16 text-bold text-black">{{ order.plan_total_hour }}</span>
                  {{ order.standard_unit }}
                </span>
              </el-form-item>

              <el-form-item v-if="order.report_remark" label="报工备注">
                <span>{{ order.report_remark }}</span>
              </el-form-item>

              <el-form-item :label="order.status == 90 ? '报工工时' : '结单工时'" class="mt">
                <div class="line"></div>
                <div v-for="(operator, index) in order.operators" :key="'key' + index" class="flex port-item line">
                  <span>
                    <f-user-avatar :user="operator"></f-user-avatar>
                    <f-user-name :user="operator" class="ml-sm"></f-user-name>
                  </span>
                  <span>
                    <el-input style="width: 120px" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" v-model="operator.confirm_hour"></el-input>
                    <span class="ml-sm text-muted mr-sm">{{ order.standard_unit }}</span>
                  </span>
                </div>
                <div v-show="Number(order.plan_total_hour) && !equal &&	order.status == 90" class="t-btn" @click="setWorkerTime">使用派工工时填充</div>
              </el-form-item>
              <el-form-item label="结单备注" class="mt">
                <el-input type="textarea" :rows="2" placeholder clearable v-model="order.confirm_remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-scrollbar>
        <div class="text-center mt-lg">
          <el-button v-if="order.status == 90 && !billed" type="primary" class="extend" @click="submit2(1)">{{ "结 单" }}</el-button>
          <el-button v-else-if="billed" class="extend" @click="submit2(1)" @mouseenter.native="enter" @mouseleave.native="leave" plain>{{ desc }}</el-button>
          <el-button v-else-if="order.status == 100 && !updated" type="primary" class="extend" @click="submit2(2)">{{ "修 改" }}</el-button>
          <el-button v-else-if="updated" class="extend" @click="submit2(2)" @mouseenter.native="enter2" @mouseleave.native="leave2" plain>{{ desc2 }}</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="front-line mb" style="margin-left: 50px">新工单</div>
        <el-scrollbar style="height:520px;">
          <div v-loading="loading2" class="pb" style="width: 480px;margin: 0px auto;">
            <el-form ref="neworderForm" :model="neworder" :rules="neworderRules" label-position="left" class="new-form" label-width="120px">
              <el-form-item label="工单号" prop="workorder_no">
                <el-row>
                  <el-col :span="11">
                    <el-input v-model="neworder.workorder_no" clearable />
                  </el-col>
                  <el-col :span="13" class="flex" style="justify-content: flex-end">
                    <el-button type="text" @click="cancel">取消拆分</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item class="mt" label="制号">
                <mes-num-selector v-model="neworder.mfgid" placeholder="选择制号" />
              </el-form-item>
              <el-form-item class="mt" label="部件">
                <part-selector v-model="neworder.mid" :no="neworder.material_title" :mfgid="neworder.mfgid" placeholder="选择部件" />
              </el-form-item>
              <el-form-item class="mt" label="工序内容" prop="processid">
                <pp-process-selector v-model="neworder.processid" placeholder="请选择" :no="neworder.process_no" @change="getProcess" />
                <div v-if="process_remark" class="mt process-remark">
                  <div>备注信息：</div>
                  <div>{{process_remark}}</div>
                </div>
              </el-form-item>
              <el-form-item class="mt" label="派工工时" prop="standard_hour">
                <el-row>
                  <el-col :span="12">
                    <div class="flex align-items-center">
                      <el-input-number v-model="neworder.standard_hour" :min="0" :controls="false" placeholder="额定工时" style="width: 120px"></el-input-number>
                      <span class="ml-xs">{{unit}}/件</span>
                    </div>
                  </el-col>
                  <el-col :span="11" :offset="1">
                    <div class="flex align-items-center">
                      <el-input-number v-model="neworder.add_hour" :min="0" :controls="false" placeholder="附加工时" style="width: 120px"></el-input-number>
                      <span class="ml-xs">{{unit}}</span>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item class="mt" label="派工数量" prop="plan_num">
                <div class="flex align-items-center">
                  <el-input-number v-model="neworder.plan_num" :controls="false" :precision="1" :min="0.1" style="width:120px"></el-input-number>
                  <span class="ml-xs">件</span>
                </div>
              </el-form-item>
              <el-form-item class="mt" label="工位">
                <pp-station-selector v-model="neworder.stationid" placeholder="请选择" />
              </el-form-item>
              <el-form-item class="mt" label="计划时间" prop="plan_endtime">
                <el-date-picker
                  v-model="time"
                  type="datetimerange"
                  range-separator="—"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="timestamp"
                  :default-time="['8:00:00', '18:00:00']"
                  style="width: 100%;"
                />
              </el-form-item>
              <el-form-item class="mt" label="备注" prop="remark">
                <el-input v-model="neworder.remark" size="small" type="textarea" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-scrollbar>
        <div class="text-center mt-lg">
          <el-button type="primary" class="extend" @click="splitSubmit">拆分</el-button>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { checkOrderApi } from "@/api/kpi/kpiApi";
import {
  getMesWorkorderApi,
  preWorkorderNoApi,
  postMesWorkorderApi,
} from "@/api/mes/workorderApi";
import { mapState } from "vuex";

export default {
  name: "WorkOrderSplit",

  components: {
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
    PpStationSelector: () => import("@/views/pp/components/PpStationSelector"),
    PpProcessSelector: () => import("@/views/pp/components/PpProcessSelector"),
    PartSelector: () => import("@/views/mm/components/PartSelector"),
  },

  props: {
    split: {
      type: Boolean,
      default: false,
    },
    workorderid: {
      type: Number,
    },
  },

  computed: {
    totalTime() {
      let total = 0;
      this.order.operators.forEach((item) => {
        total = total + Number(item.confirm_hour);
      });
      return total;
    },

    equal() {
      return this.totalTime === this.order.plan_total_hour;
    },
    splitShow: {
      get() {
        return this.split;
      },
      set(val) {
        this.$emit("update:split", val);
      },
    },
    ...mapState({
      unit(state) {
        let temp = state.godStore.god_setting.workorder_standard_unit || "";
        switch (temp) {
          case "hour":
            return "h";
          case "minute":
            return "min";
          case "second":
            return "s";
        }
      },
    }),
    time: {
      get() {
        if (this.neworder.plan_starttime && this.neworder.plan_endtime) {
          return [
            this.neworder.plan_starttime * 1000,
            this.neworder.plan_endtime * 1000,
          ];
        } else {
          return null;
        }
      },
      set(val) {
        if (val !== null) {
          this.neworder.plan_starttime = val[0] / 1000;
          this.neworder.plan_endtime = val[1] / 1000;
        }else {
          this.neworder.plan_starttime = '';
          this.neworder.plan_endtime = '';
        }
      },
    },
  },

  data() {
    return {
      loading: false,
      loading2: false,
      order: {
        operators: [],
        confirm_remark: "",
      },

      neworder: {
        workorder_no: null,
        workorderid: null,
        processid: null,
        mid: null,
        mfgid: null,
        plan_starttime: null,
        plan_endtime: null,
        standard_hour: null,
        add_hour: null,
        plan_num: 1,
        stationid: null,
        remark: "",
        material_title: null,
        process_no: null,
      },
      neworderRules: {
        workorder_no: [
          { required: true, message: "工单号不能为空", trigger: "blur" },
        ],
        processid: [
          { required: true, message: "工序不能为空", trigger: "change" },
        ],
      },
      process_remark: "",
      billed: false,
      updated: false,
      desc: "已结单",
      desc2: "已修改",
    };
  },

  created() {
    if (this.split) this.fetchData();
    this.fetchNo();
  },

  methods: {
    fetchData() {
      this.loading = true;
      getMesWorkorderApi({ workorderid: this.workorderid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.order = Object.assign({}, this.order, res.data);
          if (this.split) {
            this.neworder = Object.assign({}, this.neworder, {
              processid: res.data.processid,
              mid: res.data.mid,
              mfgid: res.data.mfgid,
              plan_starttime: res.data.plan_starttime,
              plan_endtime: res.data.plan_endtime,
              standard_hour: res.data.standard_hour,
              add_hour: res.data.add_hour,
              plan_num: res.data.plan_num,
              stationid: res.data.stationid,
              remark: res.data.remark,
              material_title: res.data.material_title,
              process_no: res.data.process_no,
            });
          }
          this.order.operators.forEach((item) => {
            if (this.order.status == 90) {
              item.confirm_hour = item.report_hour;
            }
          });
        }
      });
    },

    fetchNo() {
      this.loading2 = true;
      preWorkorderNoApi().then((res) => {
        this.loading2 = false;
        if (!res.errno) {
          this.neworder.workorder_no = res.data;
        }
      });
    },

    setWorkerTime() {
      this.order.operators.forEach((item) => {
        if (this.order.status == 90) {
          item.confirm_hour = Math.abs(
            this.order.plan_total_hour *
              (item.report_hour / this.order.report_total_hour)
          );
        }
      });
    },

    submit2(e) {
      this.$refs["orderForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let { workorderid, operators, confirm_remark } = this.order;
          checkOrderApi({ workorderid, operators, confirm_remark }).then(
            (res) => {
              this.loading = false;
              if (!res.errno) {
                this.$emit("success");
                this.$message.success(
                  this.order.status == 90 ? "结单成功" : "修改结单信息成功"
                );
                if (e == 1) {
                  this.billed = true;
                } else {
                  this.updated = true;
                }
                this.fetchData();
              } else {
                this.$message.error(res.message);
              }
            }
          );
        }
      });
    },

    splitSubmit() {
      this.$refs["neworderForm"].validate((valid) => {
        if (valid) {
          this.neworder.parent_workorderid = this.workorderid;
          this.neworder.create_scene = "split";
          if (this.order.status == 90) {
            this.$confirm("原工单还未结单，是否继续？", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }).then(() => {
              this.loading2 = true;
              postMesWorkorderApi(this.neworder).then((res) => {
                this.loading2 = false;
                if (!res.errno) {
                  this.fetchData();
                  this.$emit("success");
                  this.$message.success("拆分成功");
                  this.$emit("hide");
                } else {
                  this.$message.error(res.message);
                }
              });
            });
          } else {
            this.loading2 = true;
            postMesWorkorderApi(this.neworder).then((res) => {
              this.loading2 = false;
              if (!res.errno) {
                this.fetchData();
                this.$emit("success");
                this.$message.success("拆分成功");
                this.$emit("hide");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
      });
    },

    toDetail(order) {
      const id = order.workorderid;
      this.$detail(id);
    },

    getProcess(e) {
      if (e) {
        this.neworder.standard_hour = e.standard_hour;
        this.neworder.add_hour = e.add_hour;
        this.process_remark = e.remark;
      } else {
        this.process_remark = "";
      }
    },

    enter() {
      this.desc = "修 改";
    },

    leave() {
      this.desc = "已结单";
    },

    enter2() {
      this.desc2 = "修 改";
    },

    leave2() {
      this.desc2 = "已修改";
    },

    cancel() {
      this.$emit("hideShow");
    },

    closeDialog() {
      this.$emit("hide");
    },
  },
};
</script>


<style lang="scss" scoped>
.single-statement {
  .el-form-item {
    margin-bottom: 0px;
  }
  .port-item {
    padding: 7px 0px;
    justify-content: space-between;
  }
  .line {
    border-bottom: 1px solid #e0e3ea;
  }
  .t-btn {
    float: right;
    color: #e6a23c;
    cursor: pointer;
    &:hover {
      color: #fa9908;
    }
  }
}
.order-no:hover {
  color: #07c160;
}
.border-success {
  border: 1px solid #07c160;
  border-radius: 2px;
}
.border-danger {
  border: 1px solid #f56c6c;
  border-radius: 2px;
}
.split {
  padding: 0 5px;
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(16, 16, 16, 1);
  border-radius: 4px;
}
.split-button {
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="scss">
.new-form {
  .process-remark {
    padding: 12px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(248, 249, 252, 400);
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>
